import { HrListCampionatiPage } from './../hr_listcampionati/hr_listcampionati';
import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { HrProfiloSquadraPage } from '../hr_profilosquadra/hr_profilosquadra';
import { HrTablePage } from '../hr_table/hr_table';
// import { MultiDataSet, Label } from 'ng2-charts';
// import { ChartType } from 'chart.js';
import { saveAs } from 'file-saver';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { HrCaricaUtente } from '../hr_caricautente/hr_caricautente';
import { TranslateService } from '@ngx-translate/core';
import { HrListUtentiPage } from '../hr_listutenti/hr_listutenti';
import { HrEmailInvito } from '../hr_emailinvito/hr_emailinvito';
// import 'chart.piecelabel.js';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-hr_graphcampionati',
  templateUrl: 'hr_graphcampionati.html',
})
export class HrGraphCampionatiPage extends Util {
  pagine: any;
  language = 'it';
  user: any;
  mjl: any;
  page: string;
  percent_hat = '20%';
  itemExpandHeight = 250;
  refresh_dashboard: boolean = false;
  grafici: any = null;
  gironi: any = [];
  percorsi: any = [];
  squadre: any = [];
  precisione: any = {};
  velocita: any = {};
  showCompletamento: boolean = false;
  showupload: boolean = false;
  showDownloadTracciati: boolean = false;
  showGestioneUtenti: boolean = false;
  girone_selected: any = '-1';
  dichiarazione_ok: boolean = false;
  showEmailInvito: boolean = false;
  public doughnutChartLabels = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  public doughnutChartData = [
    [350, 450, 100],
    [50, 150, 120],
    [250, 130, 70],
  ];
  public doughnutChartType = 'doughnut';
  public bubbleChartColors = [
    {
      backgroundColor: [
        'red',
        'green',
        'blue',
        'purple',
        'yellow',
        'brown',
        'magenta',
        'cyan',
        'orange',
        'pink'
      ]
    }
  ];

  mostraFiltriAvanzati: boolean = false;

  public bubbleChartOptions = {
    responsive: true,
    scales: {
      xAxes: [
        {
          ticks: {
            min: 0,
            max: 30,
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            min: 0,
            max: 30,
          }
        }
      ]
    }
  };
  public bubbleChartType = 'bubble';
  public bubbleChartLegend = true;

  public bubbleChartData = [
    {
      data: [
        { x: 10, y: 10, r: 10 },
        { x: 15, y: 5, r: 15 },
        { x: 26, y: 12, r: 23 },
        { x: 7, y: 8, r: 8 },
      ],
      label: 'Series A',
      backgroundColor: 'green',
      borderColor: 'blue',
      hoverBackgroundColor: 'purple',
      hoverBorderColor: 'red',
    },
  ];

  campionato: any = {};
  constructor(public navCtrl: NavController, public translate: TranslateService, private transfer: FileTransfer, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.campionato = this.navParams.get('campionato');
    this.refreshpage();
  }

  chiedi_dichiarazione() {
    this.presentPopover({}, Confirm, 'Dichiaro di essere autorizzato al trattamento dei dati personali qui inseriti e di operare nel rispetto delle istruzioni del Titolare del trattamento, del Regolamento (UE) 2016/679 (GDPR) e della normativa nazionale vigente in materia di protezione dei dati personali').then((data) => {
      if (data == 'confirm') {
        this.dichiarazione_ok = true;
        //simulo di fare click su #file_modulo
        setTimeout(() => {
          const fileInput = document.querySelector('#file_modulox') as HTMLElement;
          if (fileInput) {
            fileInput.click();
          }
        }, 500);

      }
    });
  }

  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }, g): void {
    var ixx = '';
    if (active[0] != undefined && active[0]['_index'] != undefined) {
      ixx = active[0]['_index'];
      //console.log(active[0]['_index']);
      this.navCtrl.push(HrTablePage, { grafico: g, campionato: this.campionato.id, girone: this.girone_selected, index_click: ixx, showDownloadTracciati: this.showDownloadTracciati, premuto_filtra: this.premuto_filtra, filter_params: { gironi: this.gironi_selected, mjs: this.percorsi_selected, from_date: this.da_x, to_date: this.a_x } });
    }

  }
  open_invia_email_invito(){
    this.navCtrl.push(HrEmailInvito, { campionato: this.campionato.id });
  }
  carica_utente() {
    this.navCtrl.push(HrCaricaUtente, { campionato: this.campionato.id , params_grafici: { showEmailInvito: this.showEmailInvito , showDownloadTracciati: this.showDownloadTracciati , showCompletamento: this.showCompletamento } });
  }
  title_click(g) {
    this.navCtrl.push(HrTablePage, { grafico: g, campionato: this.campionato.id, girone: this.girone_selected, index_click: '', showDownloadTracciati: this.showDownloadTracciati, premuto_filtra: this.premuto_filtra, filter_params: { gironi: this.gironi_selected, mjs: this.percorsi_selected, from_date: this.da_x, to_date: this.a_x } });
  }
  open_profilosquadra(s, i) {
    this.navCtrl.push(HrProfiloSquadraPage, { squadra: s, pos: i, girone: this.girone_selected, campionato: this.campionato.id, showCompletamento: this.showCompletamento, showDownloadTracciati: this.showDownloadTracciati, premuto_filtra: this.premuto_filtra, filter_params: { gironi: this.gironi_selected, mjs: this.percorsi_selected, from_date: this.da_x, to_date: this.a_x } });
  }

  ricerca_utente() {
    this.navCtrl.push(HrListUtentiPage, { campionato: this.campionato.id, squadre: this.squadre, showDownloadTracciati: this.showDownloadTracciati,showEmailInvito: this.showEmailInvito });
  }

  gironi_senza_tutti = [];
  refreshpage() {

    this.GetRequest('hr_gironi', this.campionato.id).then(data => {

      this.gironi = data['GironeList'];
      this.gironi_senza_tutti = this.gironi.filter(g => g.id != '-1');
      this.mostraFiltriAvanzati = data['mostraFiltriAvanzati'];
      if (this.mostraFiltriAvanzati == true) {
        this.GetRequest('hr_microjourney', this.campionato.id).then(data => {
          // console.log('percorsi', data['MicroJourneyList']);
          this.percorsi = data['MicroJourneyList'];
          // this.percorsi_senza_tutti = this.percorsi.filter(p => p.id !== '-1');
          // if (this.gironi != null && this.gironi.length > 0)
          //   this.get_grafici(this.gironi[0].id);
        }).catch((e) => {
          console.error(e)
        })
      }
      if (this.gironi != null && this.gironi.length > 0)
        this.get_grafici(this.gironi[0].id);
    }).catch((e) => {
      console.error(e)
    })
    // VERSIONE NUOVA



  }

  selezionaTuttiGironi() {
    // if (this.gironi_selected.length == this.gironi_senza_tutti.length) {
    //   this.gironi_selected = [];
    // }
    // else {
      this.gironi_selected = this.gironi_senza_tutti.map(g => g.id);
    // }
  }

  selezionaTuttiPercorsi() {
    // if (this.percorsi_selected.length == this.percorsi.length) {
    //   this.percorsi_selected = [];
    // }
    // else {
      this.percorsi_selected = this.percorsi.map(p => p.id);
    // }
  }

  onChange(f) {

    var file = f[0];
    if (file != undefined) {
      var fileName = file.name;

      var allowedExtensions =
        ["xlsx", "xls"];
      var fileExtension = fileName.split('.').pop();

      if (allowedExtensions.indexOf(fileExtension) == -1) {
        this.showBasicAlert('Errore file', 'Sono ammessi solo file con estensioni xls o xlsx');
        return;
      }
      if (file.size > 2024000) {
        this.showBasicAlert('Errore file', 'La dimensione del file supera 2MB')
        return;
      }
    }
    if (file) {
      var reader = new FileReader();
      reader.onload = () => {
        //reader.result - base64

        this.sendfile(reader.result);

      }
      // reader.onload = function () {  
      // };
      if (f[0]) {
        reader.readAsDataURL(f[0]);
      }
      reader.onerror = function (error) {
        //console.log("Failed to load file");
      };
    }
    else {

      //console.log("Failed to load file");
    }
  }


  sendfile(base) {
    this.PostRequest('hr_upload_utenti', '', { campionato_id: this.campionato.id, base64: base }, true, true).then((res) => {
      //console.log(res);
      this.showBasicAlert('Utenti', 'Utenti caricati correttamente');
      // this.user.foto = res['path'];
      // this.params.foto = res['path'];
      // this.storage.set('user', this.user);
    }).catch((err) => {
      console.error(err);
    })
  }
  gironi_selected;
  percorsi_selected;
  da_x;
  a_x;

  premuto_filtra = false;
  filtra() {

    this.grafici = null;
    this.squadre = null;
    console.log('gironi', this.gironi_selected);
    console.log('percorsi', this.percorsi_selected);
    console.log('da', this.da_x);
    console.log('a', this.a_x);
    if (this.gironi_selected != undefined && this.percorsi_selected != undefined && this.da_x != undefined && this.a_x != undefined) {
      this.PostRequest('hr_grafici', '', { cid: this.campionato.id, from_date: this.da_x, to_date: this.a_x, gironi: this.gironi_selected, mjs: this.percorsi_selected }, true, true).then((res) => {
        // console.log(res);
        this.premuto_filtra = true;
        this.disegna_grafici(res);
      }).catch((e) => {
        console.error(e);
      })
    }
    else {
      let str = [];
      if (this.gironi_selected == undefined)
        str.push('Girone/i');
      if (this.percorsi_selected == undefined)
        str.push('Percorso/i');
      if (this.da_x == undefined)
        str.push('Data DA');
      if (this.a_x == undefined)
        str.push('Data A');
      this.showBasicAlert('Campi mancanti', 'Seleziona tutti i Parametri: ' + str.join(', '));
    }

  }
  download_template() {

    if (this.plt.is('ios') || this.plt.is('android')) {
      const fileTransfer: FileTransferObject = this.transfer.create();
      fileTransfer.download(this.download_template_up_user, 'Template_utenti_hr.xlsx').then((entry) => {
        //console.log('download complete: ' + entry.toURL());
      }, (error) => {
        // handle error
      });
    }
    else {

      const downloadLink = document.createElement("a");
      const fileName = "Template_utenti_hr.xlsx";

      downloadLink.href = this.download_template_up_user;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    // var linkSource = 'http://www.africau.edu/images/default/sample.pdf';
    // saveAs(linkSource,"a.pdf");
    // this.downloadFile(linkSource);
    // const downloadLink = document.createElement("a");
    // const fileName = "xxx.pdf";

    // downloadLink.href = linkSource;
    // // downloadLink.target = '_blank';
    // downloadLink.download = fileName;
    // downloadLink.click();

  }

  export() {
    var req = -1 + '/' + this.campionato.id + '/' + this.girone_selected;
    //gEt rEQUEST IN BACKGROUND "Sono necessari alcuni minuti per creare il file, lo invieremo al tuo indirizzo e-mail"
    if (this.premuto_filtra == true) {
      this.PostRequest('hr_esporta_grafico', '', { grafico_id: -1, cid: this.campionato.id, from_date: this.da_x, to_date: this.a_x, gironi: this.gironi_selected, mjs: this.percorsi_selected }, true, true).then((res: any) => {
        if (res != null && res.base64 != null) {
          const linkSource = `data:application/vnd.ms-excel;base64,${res.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = "esportazione_eydlab.xls";

          downloadLink.href = linkSource;
          // downloadLink.target = '_blank';
          downloadLink.download = fileName;
          downloadLink.click();
        }
        // this.showBasicAlert('Attenzione', 'Sono necessari alcuni minuti per creare il file, lo invieremo al tuo indirizzo e-mail');
      }).catch((e) => {
        console.error(e);
        this.showBasicAlert('Attenzione', 'Sono necessari alcuni minuti per creare il file, lo invieremo al tuo indirizzo e-mail');
      })
    }
    else {
      this.GetRequest('hr_esporta_grafico', req, false, false).then((x: any) => {
        //console.log(x);
        // this.showBasicAlert('Attenzione','Sono necessari alcuni minuti per creare il file, lo invieremo al tuo indirizzo e-mail'); 
        if (x != null && x.base64 != null) {
          const linkSource = `data:application/vnd.ms-excel;base64,${x.base64}`;
          const downloadLink = document.createElement("a");
          const fileName = "esportazione_eydlab.xls";

          downloadLink.href = linkSource;
          // downloadLink.target = '_blank';
          downloadLink.download = fileName;
          downloadLink.click();
        }
      }).catch((err) => {
        this.showBasicAlert('Attenzione', 'Sono necessari alcuni minuti per creare il file, lo invieremo al tuo indirizzo e-mail');
        console.error(err);
      })
    }
  }

  disegna_grafici(data) {
    this.grafici = data['grafici'];
    var g = this.grafici[2];
    var newOptions = this.clone(g.options);
    newOptions['responsive'] = true;
    newOptions['tooltips'] = {
      callbacks: {
        label: function (tooltipItem, data) {
          return tooltipItem.yLabel + ' %';
        }
      }
    };
    g.options = newOptions;
    this.grafici[2] = g;

    var gx = this.grafici[0];
    var newOptionsx = this.clone(gx.options);
    newOptionsx['responsive'] = true;
    newOptionsx['tooltips'] = {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
            return previousValue + currentValue;
          });
          var currentValue = dataset.data[tooltipItem.index];
          return data.labels[tooltipItem.index] + ": " + currentValue + "/" + total;
        }
      }
    };
    newOptionsx['pieceLabel'] = {
      mode: 'percentage',
      fontColor: 'white',
      fontSize: 10,
      textShadow: true,
      shadowColor: 'rgba(0,0,0,0.95)',
      overlap: false,
    };
    gx.options = newOptionsx;
    this.grafici[0] = gx;
    // this.grafici[1]['options']['callbacks'] = 
    this.squadre = data['squadre'];
    this.showCompletamento = data['showCompletamento'];
    this.precisione = data['precisione'];
    this.velocita = data['velocita'];
    this.showupload = data['showUpload'];
    this.showDownloadTracciati = data['showDownloadTracciati'];
    this.showGestioneUtenti = data['showGestioneUtenti'];
    this.showEmailInvito = data['showEmailInvito'];
    // this.showupload = true; 
  }


  get_grafici(idgirone) {
    this.premuto_filtra = false;
    this.girone_selected = idgirone;
    this.grafici = null;
    this.squadre = null;
    this.velocita = null;
    this.precisione = null;
    this.GetRequest('hr_grafici', idgirone + '/' + this.campionato.id).then(data => {
      this.disegna_grafici(data);
    }).catch((e) => {
      console.error(e)
    })
  }
  chartHovered(event): void {
    // console.log(event);
  }
  open_campionato(campionato) {
    // this.navCtrl.push();
  }
  back() {
    // if(this.refresh_dashboard == false)
    this.navCtrl.pop({ animate: false });
    // else
    //   this.go_root();
  }
  open_badge(i) {


    if (i.arr_expand == false) {
      this.GetRequest('badgeMJ', i.id).then(data => {
        i.badge = data['BadgeList'];
        //console.log(data);
        i.arr_expand = true;
      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })

    }

    else
      i.arr_expand = false;

  }
  go_root() {
    this.navCtrl.setRoot(HrListCampionatiPage);
  }
  // reset_badge(item) {
  //   //console.log(item);
  //   this.presentPopover(event, Confirm, 'Stai per azzerare questo percorso: i tuoi progressi e i badge che hai raccolto verranno cancellati e tutte le statistiche saranno azzerate, con la sola esclusione del tempo di allenamento complessivo, vuoi procedere?').then((data) => {
  //     //console.log(data);
  //     if (data == 'confirm') {
  //       this.presentPopover(event, Confirm, 'Una volta data conferma i dati del percorso "' + item.nome + '" verranno definitivamente cancellati e non sarà più possibile recuperarli in alcun modo. Sei certo di voler azzerare questo percorso?', 'danger').then((data_) => {
  //         if (data_ == 'confirm') {
  //           this.PostRequest('resetMJ', item.id, {}, true, true).then(data_x => {
  //             this.refresh_dashboard = true;
  //             //console.log(data_x);
  //             item.arr_expand = false;
  //           }).catch((e) => {
  //             //this.navCtrl.push(Mj_Detail,{mj:m});
  //             console.error(e)
  //           })
  //         }
  //       });
  //     }
  //   });


  // }
  show_detail_badge(b) {
    this.presentPopover(event, DetailBadge, b).then((data_) => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/hr_graphcampionati/hr_graphcampionati.ts